/** @jsx jsx */

import { useContext, useRef } from 'react';
import { css, jsx } from '@emotion/core';
import EditMarker from 'components/UI/EditMarker';
import { colors } from 'styles/variables';
import setCurrentBlock from 'services/apiHelpers/setCurrentBlock';
import { connect } from 'react-redux';
import { Button, Box } from '@chameleoncreator/creator-ui';
import { InteractionContext } from '../../Layouts/ContainerLogical';
import { useLayoutEffect } from 'react';
import checkButtonColors from 'services/checkButtonColors';
import getStore from 'services/getStore';
import isIE from 'services/isIE';
import DButton from './DButton';
import { useSelector } from 'react-redux';

const store = getStore();

const { getState } = getStore();

const { lPink } = colors;

interface IEditable {
  enabled?: boolean;
  isEditActive: boolean;
  children: any;
  lockDown: boolean;
  id: string;
  shape?: string;
  background?: string;
  foreground?: string;
  label?: string;
  color?: string;
  buttonShape?: string;
  localShape?: boolean;

  borderRadius?: number | string;
  localBorderRadius?: boolean;

  buttonShadow?: boolean;
  localShadow?: boolean;

  localButtonOutline?: boolean;
  buttonOutline?: boolean;

  borderWidth?: string;
  borderColor?: string;
  localBorderColor?: boolean;
  font?: string;
  focusColor?: string;
  onClick?: () => void;
}

const EditableBtn = (props: IEditable) => {
  const {
    enabled = undefined,
    isEditActive,
    id,
    label,
    shape,
    borderWidth,
    // borderColor,
    font,
    focusColor,
    onClick = () => {},
  } = props as any;

  const {
    buttonShape,
    buttonShadow,
    buttonOutline,
    borderColor,
    buttonBorderRadius = 0,
  } = useSelector((state: any) => {
    // props.localShape props.localShadow
    // if this is set. means author has made a decision on the button props
    // we preference this setting true or false

    const {
      buttonShape,
      buttonShadow,
      buttonOutline,
      buttonBorderColor,
      buttonBorderRadius,
    } = state.theme;

    return {
      buttonShape: props.localShape ? props.buttonShape : buttonShape,
      buttonShadow: props.localShadow ? props.buttonShadow : buttonShadow,
      buttonOutline: props.localButtonOutline
        ? props.buttonOutline
        : buttonOutline,
      borderColor: props.localBorderColor
        ? props.borderColor
        : buttonBorderColor,
      buttonBorderRadius: props.localBorderRadius
        ? props.borderRadius
        : buttonBorderRadius,
    };
  });

  const { background, color } = checkButtonColors(props);

  return window.dev() ? (
    <Box
      p={2}
      px={3}
      flex={0}
      css={css`
        position: relative;
        display: inline-flex;
        // padding: 5px;
        box-shadow: ${isEditActive
          ? `0 0 0 1px ${lPink}`
          : '0 0 0 1px lightGrey'};
        transition: box-shadow 0.2s;
        cursor: pointer;
      `}
      onClick={e => {
        e.stopPropagation();
        if (isEditActive) {
          return;
        }
        setCurrentBlock({ id });
      }}
    >
      <DButton
        id={id}
        enabled={enabled}
        shape={buttonShape}
        background={background}
        foreground={color}
        // borderWidth={borderWidth}
        borderWidth={buttonOutline ? 1 : 0}
        // borderColor={borderColor}

        buttonOutline={buttonOutline}
        borderColor={background}
        borderRadius={buttonBorderRadius}
        buttonShadow={buttonShadow}
        font={font}
        focusColor={focusColor}
        onClick={onClick}
      >
        {label}
      </DButton>
      {!isEditActive && <EditMarker />}
    </Box>
  ) : (
    <DButton
      id={id}
      enabled={enabled}
      shape={buttonShape}
      background={background}
      foreground={color}
      // borderWidth={borderWidth}
      borderWidth={buttonOutline ? 1 : 0}
      // borderColor={borderColor}

      buttonOutline={buttonOutline}
      borderColor={background}
      borderRadius={buttonBorderRadius}
      buttonShadow={buttonShadow}
      font={font}
      focusColor={focusColor}
      onClick={onClick}
    >
      {label}
    </DButton>
  );
};

export default connect(
  ({ focusedNodeId }: { focusedNodeId: string | number }, props: any) => {
    // console.log(props);
    // remove the random ' force update '
    return {
      isEditActive: focusedNodeId === props.id && props.id !== undefined,
      [Math.random()]: '',
    };
  }
)(EditableBtn);
